import React, { useEffect, useState } from "react";
import { Row, Col, Table } from "rsuite";
import { numberFormatter } from "../../utils/formatter";

const { Column, HeaderCell, Cell } = Table;

interface DataPoint {
	Opportunity: number;
	OpportunityThisMonth: number;
	Volume: number;
}

interface HistoricalTrendTableProps {
	data: DataPoint[];
}

const HistoricalTrendTable: React.FC<HistoricalTrendTableProps> = ({
	data,
}) => {
	const [tableHeight, setTableHeight] = useState<number>(250);
	useEffect(() => {
		const updateTableHeight = () => {
			setTableHeight(window.innerHeight - 220 - 405);
		};

		updateTableHeight();

		window.addEventListener("resize", updateTableHeight);

		return () => {
			window.removeEventListener("resize", updateTableHeight);
		};
	}, []);

	const attributes = [
		{
			key: "Opportunity",
			label: `Lost Opportunity 
			  cumulative ($)`,
		},
		{
			key: "OpportunityThisMonth",
			label: `Lost Opportunity 
              by month ($)`,
		},
		{ key: "Volume", label: "Volume (cs)" },
	];

	return (
		<div className="h-full">
			{data.length ? (
				<Table
					className="table-container"
					autoHeight
					data={attributes}
					showHeader={false}
					wordWrap
					bordered
					rowHeight={20}
					rowClassName={(rowData, rowIndex) => {
						if (!rowData) return "";
						let className = "rs-table-row";

						if (rowIndex % 2 === 0) {
							className += " db-tablebg";
						}

						return className;
					}}
				>
					<Column
						width={120}
						flexGrow={2}
						align="left"
						fixed
					>
						<HeaderCell>
							<div className="text-[0.75vw] font-bold">
								Attribute
							</div></HeaderCell>
						<Cell
							dataKey="label"
							style={{
								borderRight: "2px solid #bebebe",
							}}
						>
							{(rowData) => (
								<div className="table-header-text font-bold">
									{rowData["label"]}
								</div>
							)}
						</Cell>
					</Column>

					{data?.map((d: any, colIndex) => (
						<Column flexGrow={1} key={d[0]}>
							<HeaderCell align="left">
								<div className="text-[0.75vw] font-bold">
									Div
								</div>
							</HeaderCell>
							<Cell align="left" className="table-cell-text">
								{(rowData, rowIndex) => {
									const d = data[colIndex];
									switch (rowIndex) {
										case 0:
											return <div className="table-cell-text">
												{`$${numberFormatter(
													d.Opportunity
												)}`}
											</div>;
										case 1:
											return <div className="table-cell-text">{`$${numberFormatter(
												d.OpportunityThisMonth ||
												0
											)}`}</div>;
										case 2:
											return <div className="table-cell-text">
												{numberFormatter(
													d.Volume
												)}
											</div>
										default:
											return null;
									}
								}}
							</Cell>
						</Column>
					))}
				</Table>
			) : (
				<span className="h-full flex justify-center items-center italic font-normal text-[2.5vh] text-center text-black">
					Click on the left Table to get the Detailed view
				</span>
			)}
		</div>
	);
};

export default HistoricalTrendTable;
